module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "authentication"
  }, [_c('div', {
    staticClass: "ui top header"
  }, [_vm._v("Authentication")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.error_message) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error_message))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "ui celled table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "four wide"
  }, [_vm._v("Username")]), _vm._v(" "), _c('td', [(_vm.errors.first('username')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first('username')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui fluid input",
    class: {
      error: _vm.errors.first('username')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    attrs: {
      "type": "email",
      "placeholder": "Username",
      "name": "username"
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "four wide"
  }, [_vm._v("Password")]), _vm._v(" "), _c('td', [(_vm.errors.first('password')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ui fluid input",
    class: {
      error: _vm.errors.first('password')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    staticClass: "ui button green",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.authenticate()
      }
    }
  }, [_vm._v("\n              Log In\n            ")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d8c2560","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Authentication.vue
// module id = 488
// module chunks = 1